"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.LogwebAPI = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _NextApiClient = require("./NextApiClient");
var LogwebAPI = /*#__PURE__*/function () {
  function LogwebAPI() {
    (0, _classCallCheck2["default"])(this, LogwebAPI);
  }
  (0, _createClass2["default"])(LogwebAPI, null, [{
    key: "guestLogin",
    value: function guestLogin(modo) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        Modo: modo
      };
      _NextApiClient.NextApiClient.com(this.service, 'GuestGetUID', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "guestLoginChain",
    value: function guestLoginChain(modo, chainId) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        Modo: modo,
        chainid: chainId
      };
      _NextApiClient.NextApiClient.com(this.service, 'GuestGetUIDChain', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "login",
    value: function login(userId, userName, pwd) {
      var shopId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (j) {
        console.error(j);
      };
      var params = {
        UserID: userId,
        UserName: userName,
        Password: pwd,
        ShopId: shopId
      };
      _NextApiClient.NextApiClient.com(this.service, 'jWebLogin', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "loginCustomID",
    value: function loginCustomID(userId, pwd) {
      var shopId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        CustomID: userId,
        Password: pwd,
        ShopId: shopId
      };
      _NextApiClient.NextApiClient.com(this.service, 'jWebLoginCustomID', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "loginChain",
    value: function loginChain(userId, userName, pwd, shopId, chainId) {
      var cb = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function (j) {
        console.error(j);
      };
      var params = {
        UserID: userId,
        UserName: userName,
        Password: pwd,
        ShopId: shopId,
        chainid: chainId
      };
      _NextApiClient.NextApiClient.com(this.service, 'jWebLoginChain', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "rsaLogin",
    value: function rsaLogin() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.error(j);
      };
      var params = {};
      _NextApiClient.NextApiClient.com(this.service, 'RSALoginUser', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "rsaLoginChain",
    value: function rsaLoginChain() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.error(j);
      };
      var params = {};
      _NextApiClient.NextApiClient.com(this.service, 'RSALoginUserChain', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "adalLogin",
    value: function adalLogin() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.error(j);
      };
      var params = {};
      _NextApiClient.NextApiClient.com(this.service, 'jADALogin', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "adalLoginChain",
    value: function adalLoginChain() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.error(j);
      };
      var params = {};
      _NextApiClient.NextApiClient.com(this.service, 'jADALoginChain', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "chooseShop",
    value: function chooseShop(shopCod) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        cod: shopCod
      };
      _NextApiClient.NextApiClient.com(this.service, 'jWebChooseShop', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "createUser",
    value: function createUser(username, password, creationId) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        userid1: username,
        password: password,
        creationid: creationId,
        userid2: '',
        proposedid: 0
      };
      _NextApiClient.NextApiClient.com(this.service, 'CustomCreateNewUser', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "inviteUser",
    value: function inviteUser(useremail, password) {
      var abvendita = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var creationId = arguments.length > 3 ? arguments[3] : undefined;
      var FeEndpoint = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window.location.origin;
      var extra = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var cb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : function (j) {
        console.error(j);
      };
      if (typeof extra != 'string') {
        extra = (0, _stringify["default"])(extra);
      }
      var params = {
        useremail: useremail,
        password: password,
        creationid: creationId,
        FeEndpoint: FeEndpoint,
        abvendita: abvendita,
        extra: extra
      };
      _NextApiClient.NextApiClient.com(this.service, 'CustomInviteNewUser', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "deleteUser",
    value: function deleteUser(userId, creationId) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        userid: userId,
        creationid: creationId
      };
      _NextApiClient.NextApiClient.com(this.service, 'CustomDeleteUser', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getBeVersion",
    value: function getBeVersion() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'GetBackendVersion', {}, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "lostPassword",
    value: function lostPassword(userid) {
      var endpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.origin + '/#/resetpassword';
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (err) {
        console.error(err);
      };
      var params = {
        userid: userid,
        FeEndpoint: endpoint
      };
      _NextApiClient.NextApiClient.com(this.service, 'LostPassword', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(code, pwd, pwdConf) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (err) {
        console.error(err);
      };
      var params = {
        code: code,
        pwd: pwd,
        pwdConf: pwdConf
      };
      _NextApiClient.NextApiClient.com(this.service, 'ResetPassword', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "changeGDPRFlags",
    value: function changeGDPRFlags(flags) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        privacySettings: flags
      };
      _NextApiClient.NextApiClient.comg(this.service, 'jChangeGDPRFlags ', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "OauthSignin",
    value: function OauthSignin(access_token, authority, chainid) {
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'COMPUSOFT';
      var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (err) {
        console.error(err);
      };
      var params = {
        access_token: access_token,
        authority: authority,
        chainid: chainid,
        type: type
      };
      _NextApiClient.NextApiClient.com(this.service, 'jOauth2Signin', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "ImportCustomUsersData",
    value: function ImportCustomUsersData(creationid, data) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (err) {
        console.error(err);
      };
      var params = {
        _UID: _NextApiClient.NextApiClient.getUID(),
        creationid: creationid,
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.comg(this.service, 'ImportCustomUsersData', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "startMaintenance",
    value: function startMaintenance(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        _UID: _NextApiClient.NextApiClient.getUID(),
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.comg(this.service, 'startMaintenance', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "endMaintenance",
    value: function endMaintenance(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        _UID: _NextApiClient.NextApiClient.getUID(),
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.comg(this.service, 'endMaintenance', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "isMaintenance",
    value: function isMaintenance(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.comg(this.service, 'isMaintenance', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "bookedMaintenanceSet",
    value: function bookedMaintenanceSet(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        _UID: _NextApiClient.NextApiClient.getUID(),
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.comg(this.service, 'bookedMaintenanceSet', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }]);
  return LogwebAPI;
}();
exports.LogwebAPI = LogwebAPI;
LogwebAPI.service = 'logweb';
//# sourceMappingURL=LogwebAPI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/api/LogwebAPI.js
// module id = 1230
// module chunks = 142